import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import CorrectAnswer from '../../assets/correct_answer.svg'
import information from '../../assets/informationIcon.svg'
import WrongAnswer from '../../assets/wrong_answer.svg'
import InstructionsModal from '../InstructionsModal/InstructionsModal'
import { answerKeyByLang, solutionKeyByLang } from '../../constants/langTypes'
import Mathjax from 'components/Mathjax'

import './MatrixTypeAnswer.css'

const MatrixTypeAnswer = (props) => {
    const { t, i18n } = useTranslation()
    const [isCorrectAnswer, setIsCorrectAnswer] = useState(false)
    const [show, setShow] = useState(false)
    const [currentLng, setCurrentLng] = useState('en')

    useEffect(() => {
        let flag = 1
        props.data.question.answerbyUser = props.data.question.answerbyUser.filter(
            (item) => item != '',
        )
        if (
            props.data.question.answerbyUser.length ==
            props.data.question.english_answer?.answer?.length
        ) {
            props.data.question.answerbyUser.map((item) => {
                if (props.data.question.english_answer.answer.indexOf(item) == -1) {
                    flag = 0
                    return
                }
            })
            if (flag) setIsCorrectAnswer(true)
        }
    }, [])

    useEffect(() => {
        setCurrentLng(i18n.language)
    }, [i18n.language])

    const handleModal = () => {
        setShow(!show)
    }
    return (
        <div className="matrix-container">
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <span className="ans-description">
                    {t('One/More correct answer(s) for each option')}
                </span>
                {props.mock ? (
                    <span className="difficulty-level">
                        {t(
                            props.data.question.lod == 'E'
                                ? 'Easy'
                                : props.data.question.lod == 'M'
                                ? 'Medium'
                                : 'Difficult',
                        )}
                    </span>
                ) : null}
                {!props.mock && (
                    <span style={{ marginBottom: '14px', marginTop: '45px' }}>
                        <img
                            src={information}
                            onClick={handleModal}
                            style={{
                                height: '17px',
                                width: '17px',
                                cursor: 'pointer',
                            }}
                        />
                    </span>
                )}
            </div>
            {show ? <InstructionsModal matrix={true} show={show} /> : ''}
            <div className="matrix">
                {props.mock && props.data.question.isAnswered ? (
                    <div
                        style={{
                            color: `${isCorrectAnswer ? '#2dce89' : '#f5365c'}`,
                            fontSize: '15px',
                            fontWeight: 'bold',
                        }}
                    >
                        <img
                            style={{ marginRight: '5px' }}
                            src={isCorrectAnswer ? CorrectAnswer : WrongAnswer}
                        />
                        {t(isCorrectAnswer ? 'Correct Answer' : 'Your Answer')}
                    </div>
                ) : null}
                <div style={{ display: 'flex' }}>
                    {!props.mock ||
                    (props.mock && props.data.question.isAnswered) ? (
                        <>
                            <div className="option-names">
                                {props.data.question[
                                    answerKeyByLang[currentLng]
                                ]?.list1.map((data, i) => {
                                    return <span>{data}</span>
                                })}
                            </div>
                            <div className="option-values">
                                {props.data.question[
                                    answerKeyByLang[currentLng]
                                ]?.list1.map((data, i) => {
                                    return (
                                        <div
                                            className={
                                                props.mock
                                                    ? isCorrectAnswer
                                                        ? 'option-value-mock'
                                                        : 'option-value-mock2'
                                                    : 'option-value'
                                            }
                                        >
                                            {props.data.question.english_answer.list2.map(
                                                (item, j) => {
                                                    return (
                                                        <span
                                                            onClick={() =>
                                                                props.mock
                                                                    ? null
                                                                    : props.onClick(
                                                                          `${
                                                                              parseInt(
                                                                                  i,
                                                                              ) + 1
                                                                          },${
                                                                              parseInt(
                                                                                  j,
                                                                              ) + 1
                                                                          }`,
                                                                          props.data,
                                                                      )
                                                            }
                                                            className={
                                                                props.isPreview &&
                                                                props.data.question.english_answer.answer?.includes(
                                                                    parseInt(i + 1) +
                                                                        ',' +
                                                                        parseInt(
                                                                            j + 1,
                                                                        ),
                                                                )
                                                                    ? 'option-value-span answer'
                                                                    : props.data.question.answerbyUser.includes(
                                                                          parseInt(
                                                                              i + 1,
                                                                          ) +
                                                                              ',' +
                                                                              parseInt(
                                                                                  j +
                                                                                      1,
                                                                              ),
                                                                      )
                                                                    ? 'option-value-span selected'
                                                                    : 'option-value-span'
                                                            }
                                                        >
                                                            {item}
                                                        </span>
                                                    )
                                                },
                                            )}
                                        </div>
                                    )
                                })}
                            </div>
                        </>
                    ) : null}
                </div>
                {props.mock && !isCorrectAnswer ? (
                    <>
                        <div
                            style={{
                                color: '#2dce89',
                                fontSize: '15px',
                                fontWeight: 'bold',
                            }}
                        >
                            <img
                                style={{ marginRight: '5px' }}
                                src={CorrectAnswer}
                            />
                            {t('Correct Answer')}
                        </div>
                        <div style={{ display: 'flex' }}>
                            <div className="option-names">
                                {props.data.question[
                                    answerKeyByLang[currentLng]
                                ]?.list1.map((data, i) => {
                                    return <span key={i}>{data}</span>
                                })}
                            </div>
                            <div className="option-values">
                                {props.data.question[
                                    answerKeyByLang[currentLng]
                                ]?.list1.map((data, i) => {
                                    return (
                                        <div className="option-value-mock" key={i}>
                                            {props.data.question.english_answer.list2.map(
                                                (item, j) => {
                                                    return (
                                                        <span
                                                            className={
                                                                props.data.question.english_answer.answer.includes(
                                                                    parseInt(i + 1) +
                                                                        ',' +
                                                                        parseInt(
                                                                            j + 1,
                                                                        ),
                                                                )
                                                                    ? 'selected'
                                                                    : null
                                                            }
                                                        >
                                                            {item}
                                                        </span>
                                                    )
                                                },
                                            )}
                                        </div>
                                    )
                                })}
                            </div>
                        </div>
                    </>
                ) : null}
                {props.mock ? (
                    <>
                        <div
                            style={{
                                textAlign: 'center',
                                margin: '20px 0px',
                                fontSize: '16px',
                            }}
                        >
                            {!isCorrectAnswer ? (
                                props.data.question.isAnswered ? (
                                    <>
                                        <div
                                            style={{
                                                color: '#f5365c',
                                                fontWeight: 'bold',
                                            }}
                                        >
                                            {t('Your answer is incorrect!')}
                                        </div>
                                        {/*<div style={{ color: "#a1aeb7", fontWeight: 500 }}>*/}
                                        {/*  Try again*/}
                                        {/*</div>*/}
                                    </>
                                ) : null
                            ) : (
                                <>
                                    <div
                                        style={{
                                            color: '#2dce89',
                                            fontWeight: 'bold',
                                        }}
                                    >
                                        {t('Your answer is correct!')}
                                    </div>
                                    <div
                                        style={{ color: '#a1aeb7', fontWeight: 500 }}
                                    >
                                        {t('Well done here is the solution')}
                                    </div>
                                </>
                            )}
                        </div>
                        <div
                            style={{
                                border: '1px solid #00b0f5',
                                justifyContent: 'center',
                                padding: '25px',
                                borderRadius: '10px',
                                overflow: 'auto',
                            }}
                        >
                            <div
                                style={{
                                    fontSize: '20px',
                                    fontWeight: 'bold',
                                    color: '#00b0f5',
                                }}
                            >
                                {t('Solution')}
                            </div>

                            <Mathjax
                                html={props.getAppendImgUrl(
                                    `<p>${
                                        props.data.question[
                                            solutionKeyByLang[currentLng]
                                        ]
                                    }</p>`,
                                )}
                            />
                        </div>
                    </>
                ) : null}
            </div>
        </div>
    )
}

export default MatrixTypeAnswer
